import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'LegalTemplate',
  components: {
    GlobalTitle: GlobalTitle,
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      backgroundImage: '',
      show: false
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref8, _ref9;

      return {
        title: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.title) != null ? (_ref9 = _ref9[0]) != null ? _ref9.text : _ref9 : _ref9 : _ref9) || '',
        description: ((_ref8 = this.payload) != null ? _ref8.description : _ref8) || [],
        articles: this.payload.articles.map(function (i) {
          var _ref5, _ref6, _ref7;

          return {
            title: ((_ref7 = i) != null ? (_ref7 = _ref7.title) != null ? (_ref7 = _ref7[0]) != null ? _ref7.text : _ref7 : _ref7 : _ref7) || '',
            heading: ((_ref6 = i) != null ? (_ref6 = _ref6.title) != null ? _ref6[0] : _ref6 : _ref6) || {},
            contents: ((_ref5 = i) != null ? _ref5.description : _ref5) || []
          };
        }),
        header: {
          color: ((_ref4 = this.payload) != null ? _ref4.color_text : _ref4) || '#3C3C3B',
          title: ((_ref3 = this.payload) != null ? _ref3.title : _ref3) || [],
          image: {
            small: formatPrismicImage((_ref2 = this.payload) != null ? (_ref2 = _ref2.background_image) != null ? _ref2.url : _ref2 : _ref2) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref = this.payload) != null ? (_ref = _ref.background_image) != null ? _ref.url : _ref : _ref) || EMPTY_PIXEL
          }
        }
      };
    }
  },
  mounted: function mounted() {
    if (this.currentPayload.header.image.small) {
      this.backgroundImage = "".concat(this.currentPayload.header.image.small, " 320w, ").concat(this.currentPayload.header.image.large, " 1440w");
    }
  },
  methods: {
    showMobileMenu: function showMobileMenu(e) {
      if (this.show === false) {
        this.show = !this.show;

        if (window.matchMedia('(max-width: 640px)').matches) {
          e.preventDefault();
        }

        document.querySelector('.arrow').classList.add('opened');
      } else {
        this.show = false;
        document.querySelector('.arrow').classList.remove('opened');
      }
    }
  }
};